<template>
  <div class="wrapper">
    <div class="filter white_box">
      <!-- <el-select
        class="custom-os"
        v-model="selectedValue"
        @change="getSalaryData"
        clearable
        filterable
        default-first-option
        size="medium"
        placeholder="请选择组织或输入关键字搜索"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select> -->
      <el-select
        class="custom-os"
        v-model="cycle"
        @change="changeHandle1_2"
        filterable
        default-first-option
        size="medium"
        placeholder="请选择统计周期"
      >
        <el-option
          v-for="item in cycleOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        class="custom-zone"
        v-model="during"
        type="monthrange"
        align="center"
        unlink-panels
        range-separator="~"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="changeHandle1_3"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </div>
    <div class="result white_box">
      <div class="h_padding48 content">
        <div class="line_box box">
          <!-- 柱状图容器 -->
          <div id="bar"></div>

          <div class="download">
            <a class="download_pic" @click="downloadPicture('bar', '薪酬发放金额统计图')">保存图片</a>
            <!-- <a class="download_pic" @click="downloadPicture()">
              <img src="@/assets/icons/Picturedownload@2x.png" alt />
            </a> -->
            
          </div>
        </div>
        <!-- 柱状图右侧的图例 -->
        <div class="legends">
          <div class="legend-item row">
            <span class="point" style="background: #5c74f5"></span>
            <p class="font_14_gray legend-name">发薪总金额</p>
            <div class="row">
              <p class="font_24_black">{{ detailData.periodTotalAmount }}</p>
              <img
                v-show="upOrDown(detailData.periodTotalAmountQoQ) > 0"
                src="@/assets/icons/up@2x.png"
                alt
              />
              <img
                v-show="upOrDown(detailData.periodTotalAmountQoQ) < 0"
                src="@/assets/icons/down@2x.png"
                alt
              />
              <span
                v-show="upOrDown(detailData.periodTotalAmountQoQ) > 0"
                class="font_12_green"
                >{{
                  Math.abs(upOrDown(detailData.periodTotalAmountQoQ))
                }}%</span
              >
              <span
                v-show="upOrDown(detailData.periodTotalAmountQoQ) < 0"
                class="font_12_red"
                >{{
                  Math.abs(upOrDown(detailData.periodTotalAmountQoQ))
                }}%</span
              >
            </div>
          </div>
          <div class="legend-item row">
            <span class="point" style="background: #5c74f5"></span>
            <p class="font_14_gray legend-name">个税总金额</p>
            <div class="row">
              <p class="font_24_black">
                {{ detailData.periodTotalDeductionAmount }}
              </p>
            </div>
          </div>
          <div class="legend-item row">
            <span class="point" style="background: #5c74f5"></span>
            <p class="font_14_gray legend-name">平均工资</p>
            <div class="row">
              <p class="font_24_black">{{ detailData.periodAverageWage }}</p>
              <img
                v-show="upOrDown(detailData.periodAverageWageQoQ) > 0"
                src="@/assets/icons/up@2x.png"
                alt
              />
              <img
                v-show="upOrDown(detailData.periodAverageWageQoQ) < 0"
                src="@/assets/icons/down@2x.png"
                alt
              />
              <span
                v-show="upOrDown(detailData.periodAverageWageQoQ) > 0"
                class="font_12_green"
                >{{
                  Math.abs(upOrDown(detailData.periodAverageWageQoQ))
                }}%</span
              >
              <span
                v-show="upOrDown(detailData.periodAverageWageQoQ) < 0"
                class="font_12_red"
                >{{
                  Math.abs(upOrDown(detailData.periodAverageWageQoQ))
                }}%</span
              >
            </div>
          </div>
          <div class="legend-item row">
            <span class="point" style="background: #5c74f5"></span>
            <p class="font_14_gray legend-name">发放人数</p>
            <div class="row">
              <p class="font_24_black">{{ detailData.periodPayTimes }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  downloadPic,
  Bar,
  dateConvert,
  zoneCheck,
  initZone,
  translateWidth
} from '@/js/tool.js'
import { Get, Download } from '@/js/http.js'

export default {
  components: {},
  props: {},
  data () {
    return {
      selectedValue: '', // 组织id
      customerShortName: '', // 客户简称，用于水印
      options: [], // 可选组织
      cycle: 0, // 周期 (0-月度、1-季度、2-年度)
      cycleOptions: [
        {
          value: 0,
          label: '月度'
        },
        {
          value: 1,
          label: '季度'
        },
        {
          value: 2,
          label: '年度'
        }
      ], // 周期可选
      during: [], // 时间区间，array或null，包含开始时间和结束时间的Date对象
      zoneObj: {}, // 时间区间已选的时间点
      // 日期选择器高级选项
      pickerOptions: {
        // 禁用机制
        disabledDate: time => {
          if (this.cycle === 0) {
            return false
          } else {
            let type = this.cycle === 2 ? 'year' : 'quarter'
            if (!this.zoneObj.maxDate && this.zoneObj.minDate) {
              // 该组件默认第一个选中的为minDate
              return !zoneCheck(time, {
                type,
                selected: this.zoneObj.minDate
              })
            } else {
              return !zoneCheck(time, { type })
            }
          }
        },
        // 点击机制
        onPick: zoneObj => {
          this.zoneObj = zoneObj
        }
      },

      chartImgUrl: '', // 图片base64
      sourceData1: {}, // 报表源数据
      detailData: {}, // 报表右侧数据
      barData: {},
      charts: {} // echarts实例
    }
  },

  computed: {
    // 开始时间
    EffectTimeStart () {
      if (this.during.length != 0) {
        return dateConvert(this.during[0], {
          format: 'Y-M'
        })
      } else {
        return ''
      }
    },
    // 结束时间
    EffectTimeEnd () {
      if (this.during.length != 0) {
        return dateConvert(this.during[1], {
          format: 'Y-M'
        })
      } else {
        return ''
      }
    }
  },
  watch: {
    cycle: {
        handler (newVal, oldVal) {
          // 周期变化时自动更新日期范围（初始化时不触发）
          if (oldVal !== undefined && oldVal !== newVal) {
            let type = newVal === 0 ? 'm' : newVal === 1 ? 'q' : 'y'
            let num = newVal === 0 ? 6 : newVal === 1 ? 2 : 1 // 月度默认6个月，季度默认2个季度，年度默认1年
            this.during = initZone(type, num)
            this.getSalaryData()
          }
        }
      }
  },
  methods: {
    // 获取组织选项
    getOptions () {
      Get('api/v1/customers/selectors').then(({ data }) => {
        this.options = data
        // this.selectedValue = data[0].value;
        // this.selectedValue2 = data[0].value;
      })
    },
    // 获取客户信息
    getCustomerInfo () {
      Get('api/v1.0/customers/info').then(res => {
        if (res.data && res.data.customerShortName) {
          this.customerShortName = res.data.customerShortName
        }
      }).catch(() => {
        this.customerShortName = '武汉行舟'
      })
    },
    // 获取薪酬数据
    getSalaryData () {
      // 假如未选择区间
      if (!this.during) {
        return false
      }
      this.detailData = {}

      Get('api/v1/reports/salary/amounts', {
        ReportType: this.cycle,
        BeginMonth: this.EffectTimeStart,
        EndMonth: this.EffectTimeEnd
      }).then(res => {
        let data = res.data
        console.log('API返回数据:', data)
        console.log('周期:', this.cycle)
        console.log('开始时间:', this.EffectTimeStart)
        console.log('结束时间:', this.EffectTimeEnd)
        if (!data || data.length === 0) {
          this.sourceData1 = []
          this.detailData = {}
          return
        }
        this.sourceData1 = data
        // 默认显示最后一个周期的数据
        this.detailData = data[data.length - 1] || {}
        let xArray = data.map(item => item.periodLabel)
        console.log('X轴数据:', xArray)
        let barData = {
          xArray: xArray,
          legend: ['发薪总金额'],
          valueData: [
            data.map(item => item.periodTotalAmount)
          ]
        }
        this.barData = barData
        this.charts = this.drawBar('bar', barData)
      })
    },
    // 判断百分数正负
    upOrDown (percent) {
      if (percent) {
        percent = percent.replace('%', '')
        percent = Number(percent)
        return percent
      } else {
        return ''
      }
    },

    changeHandle1_1 () {},
    changeHandle1_2 () {
      // 选择周期时更新日期范围并刷新数据
      console.log('选择周期:', this.cycle)
      let current = new Date()
      let currentYear = current.getFullYear()
      let currentMonth = current.getMonth() // 0-11

      let startDate, endDate

      switch (this.cycle) {
        case 0: {
          // 月度
          // 最近半年：当前月往前推5个月
          startDate = new Date(currentYear, currentMonth - 5, 1)
          endDate = new Date(currentYear, currentMonth + 1, 0)
          break
        }
        case 1: {
          // 季度
          // 本季度：按照用户要求的季度划分，显示完整季度
          let quarterStartMonth, quarterEndMonth;
          if (currentMonth >= 0 && currentMonth <= 2) { // 1-3月，第一季度
            quarterStartMonth = 0;
            quarterEndMonth = 2;
          } else if (currentMonth >= 3 && currentMonth <= 5) { // 4-6月，第二季度
            quarterStartMonth = 3;
            quarterEndMonth = 5;
          } else if (currentMonth >= 6 && currentMonth <= 9) { // 7-10月，第三季度
            quarterStartMonth = 6;
            quarterEndMonth = 9;
          } else { // 11-12月，第四季度
            quarterStartMonth = 11;
            quarterEndMonth = 11;
          }
          startDate = new Date(currentYear, quarterStartMonth, 1);
          endDate = new Date(currentYear, quarterEndMonth + 1, 0);
          break;
        }
        case 2: {
          // 年度
          // 本年：从1月1日到12月31日
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 11, 31);
          break
        }
      }

      console.log('计算的日期范围:', startDate, endDate)
      // 强制更新during，确保日期选择器能正确显示
      this.$nextTick(() => {
        this.during = [startDate, endDate]
        console.log('更新后的during:', this.during)
        // 直接调用getSalaryData()，确保数据刷新
        this.getSalaryData()
      })
    },
    changeHandle1_3 () {
      this.zoneObj = {}
      this.getSalaryData()
    },
    // 下载图片
    downloadPicture (id, title) {
      downloadPic(id, title, this.customerShortName)
      // var img = new Image();
      // img.src = this.charts.getDataURL({
      //   pixelRatio: 2,
      //   backgroundColor: "#fff"
      // });
    },
    // 下载薪酬发放金额统计excel
    downData1 () {
      Download(
        'api/v1/reports/salary/amounts/excel',
        {
          ReportType: this.cycle,
          BeginMonth: this.EffectTimeStart,
          EndMonth: this.EffectTimeEnd
        },
        '薪酬发放金额统计.xlsx'
      )
    },
    // 绘制柱状图
    drawBar (id, data) {
      return Bar.call(this, id, data, {
        title: '薪酬发放金额统计图',
        watermarkText: this.customerShortName,
        option: {
          legend: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            // 利用提示框formatter方法修改实例外变量并显示内容
            formatter: p => {
              if (p instanceof Array && p.length > 0) {
                // p[0].name是x轴标签名，即periodLabel
                const currentLabel = p[0].name

                // 更新右侧详情数据
                const foundItem = this.sourceData1.find(
                  item => currentLabel === item.periodLabel
                )
                if (foundItem) {
                  this.detailData = foundItem
                  // 显示图例数值
                  const legends = document.querySelectorAll('.legends .row');
                  legends.forEach(legend => {
                    legend.style.opacity = '1';
                  });
                }

                // 构建tooltip显示内容
                let tooltipContent = `<div style="font-weight:bold;margin-bottom:5px;">${currentLabel}</div>`

                // 遍历所有系列的数据
                p.forEach(series => {
                  // 格式化数字（如果有需要可以添加千位分隔符）
                  const value = series.value
                  const formattedValue = value ? value.toLocaleString() : '0'

                  tooltipContent += `
                <div style="display:flex;align-items:center;margin:3px 0;">
                  <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${series.color};margin-right:5px;"></span>
                  <span style="margin-right:10px;">${series.seriesName}:</span>
                  <span style="font-weight:bold;">${formattedValue}</span>
                </div>
              `
                })

                return tooltipContent
              }
              return ''
            },
            // 鼠标离开时清空详情数据
            leave: () => {
              this.detailData = {};
              // 隐藏图例数值
              const legends = document.querySelectorAll('.legends .row');
              legends.forEach(legend => {
                legend.style.opacity = '0';
              });
            }
          },
          // X 轴配置
          xAxis: [
            {
              type: "category",
              offset: 16,
              axisTick: {
                show: true,
                alignWithLabel: true,
                lineStyle: {
                  color: "#b8bac9"
                }
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9", // 刻度标签样式
                rotate: data.xArray && data.xArray.length > 6 ? 45 : 0, // 标签太多时旋转
                interval: 0 // 强制显示所有标签
              },
              boundaryGap: false,
              data: data.xArray
            }
          ],
          // Y 轴配置
          yAxis: [
            {
              type: "value",
              offset: 16,
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9" // 刻度标签样式
              }
            }
          ],
          // 网格配置
          grid: {
            left: "5%",
            right: "5%",
            bottom: "20%",
            containLabel: true
          },
          series: data.valueData.map((item, key) => {
            return {
              name: data.legend[key],
              type: 'bar',
              barWidth: translateWidth(10),
              itemStyle: {
                color: '#5c74f5',
                barBorderRadius: 50
              },
              emphasis: {
                itemStyle: {
                  // color: "#05b8fe"
                }
              },
              data: item,
              // 添加标签显示（可选）
              label: {
                show: false, // 如果需要显示数值可以改为true
                position: 'top',
                fontSize: 10
              }
            }
          })
        }
      })
    },
    // 绑定窗口缩放事件
    ifResize () {
      window.addEventListener('resize', this.resizeCharts)
    },
    // 重新设置报表大小
    resizeCharts () {
      ['charts'].forEach(item => {
        if (this[item]) {
          this[item].resize()
        }
      })
      this.drawBar('bar', this.barData)
    }
  },
  created () {},
  mounted () {
    this.getOptions()
    this.getCustomerInfo()
    this.changeHandle1_2()

    this.ifResize()
  },
  beforeDestroy () {
    // 解除事件
    window.removeEventListener('resize', this.resizeCharts)
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 150px 32px 32px;
  position: relative;
  .filter {
    padding: 22px 48px;
    margin-bottom: 32px;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 32px;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .result {
    overflow: hidden;
    .content {
      display: flex;
      padding-top: 30px;
      padding-bottom: 94px;
      background-color: #fff;
      .legends {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 82px;
        .legend-item {
          height: 28px;
          margin-bottom: 20px;
          .point {
            width: 8px;
            height: 8px;
            margin-right: 6px;
            border-radius: 50%;
          }
          .legend-name {
            min-width: 120px;
          }
          .row {
            opacity: 0;
            transition: opacity 0.3s ease;
          }
        }
      }
    }
  }
}
.line_box {
  position: relative;
  width: 898px;
  height: 530px;
  padding: 30px 80px 30px;
  box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
    0px -4px 8px 0px rgba(55, 14, 14, 0.08);
  border-radius: 10px;
  // background:url('../assets/bj.png');
}

.download {
  position: absolute;
  left: 0;
  bottom: 45px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.download_pic {
  display: inline-block;
  padding: 8px 16px;
  margin-right: 30px;
  background-color: #fff;
  border: 1px solid #f78536;
  border-radius: 4px;
  font-size: 14px;
  color: #f78536;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: #fff8f5;
    border-color: #f78536;
  }
  &:active {
    background-color: #ffe8d9;
    border-color: #f78536;
  }
}

#bar {
  width: 100%;
  height: 400px;
}
</style>
